import { pathName } from "./board";

const $header = document.querySelector('.header');
const $headerLang = document.querySelector('.header__lang');
const $headerLink = document.querySelector('.header__link');
const $introTitle1 = document.querySelector('.intro__title--1');
const $introTitle2 = document.querySelector('.intro__title--2');
const $boardTitleText = document.querySelector('.board__title-text');
// const $boardTitle2 = document.querySelector('.board__title--2');
const $boardButton = document.querySelector('.board__button');
const $boardLink = document.querySelector('.board__link');

const langRu = {
	header: {
		link: 'ПОМОЩЬ',
	},
	intro: {
		title1: 'Привет!<br><span><b>Скачай и установи</b></span> приложение <span class="title-app-name"></span><br>для своей операционной системы,<br><span><b>добавь ключ</b></span> из буфера обмена,<br><span><b>пользуйся</b></span> Интернетом&nbsp;без&nbsp;границ',
		title2: 'Привет!<br><span><b>Скачай и установи</b></span> приложение <span class="title-app-name"><b>Gate19</b></span><br>для своей операционной системы,<br><span><b>пользуйся</b></span> Интернетом&nbsp;без&nbsp;границ<br>&nbsp;',
		items: [
			{
				os: 'android',
				text: 'Скачать для<br><b>Android</b>',
			},
			{
				os: 'windows',
				text: 'Скачать для<br><b>Windows</b>',
			},
			{
				os: 'ios',
				text: 'Скачать для<br><b>IOS</b>',
			},
			{
				os: 'macos',
				text: 'Скачать для<br><b>MacOS</b>',
			},
			{
				os: 'linux',
				text: 'Выбрать<br><b>Outline</b>',
			},
		],
	},
	board: {
		protocolText: 'ключ для продвинутых пользователей',
		config2: 'ВАШ КЛЮЧ',
		download: 'СКАЧАТЬ ПРИЛОЖЕНИЕ',
		tooltip: 'скопировано',
	},
};
const langEn = {
	header: {
		link: 'SUPPORT',
	},
	intro: {
		title1: 'Hi! <br><span><b>Download and install</b></span> the app <span class="title-app-name"></span>,<br><span><b>add the key</b></span> from the clipboard,<br><span><b>use</b></span> the Internet without borders',
		title2: 'Hi! <br><span><b>Download and install</b></span> the app <span class="title-app-name"></span>,<br><span><b>use</b></span> the Internet without borders<br>&nbsp;',
		items: [
			{
				os: 'android',
				text: 'Get in on<br><b>Android</b>',
			},
			{
				os: 'windows',
				text: 'Get in on<br><b>Windows</b>',
			},
			{
				os: 'ios',
				text: 'Get in on<br><b>IOS</b>',
			},
			{
				os: 'macos',
				text: 'Get in on<br><b>MacOS</b>',
			},
			{
				os: 'linux',
				text: 'Get<br><b>Outline</b>',
			},
		],
	},
	board: {
		protocolText: 'For pro users',
		config2: 'YOUR KEY GATE19',
		download: 'DOWNLOAD',
		tooltip: 'copied',
	},
};

let changeLang = (lang) => {
	$header.classList.add('is-change');

	setTimeout(() => {
		const langCurrent = lang === 'ru' ? 'en' : 'ru';
		const langData = lang === 'ru' ? langRu : langEn;

		$headerLang.dataset.lang = langCurrent;
		$headerLink.innerHTML = langData.header.link;
		$introTitle1.innerHTML = langData.intro.title1;
		$introTitle2.innerHTML = langData.intro.title2;
		langData.intro.items.filter((item) => {
			if (['android', 'windows', 'ios', 'macos', 'linux'].includes(item.os)) {
				document.querySelector(`.intro__item--${item.os} .intro__item-text`).innerHTML = item.text;
			}
		});
		$boardTitleText.innerHTML = langData.board.protocolText;
		$boardButton.innerHTML = langData.board.download;
		$boardLink.dataset.tooltip = langData.board.tooltip;
		$header.classList.remove('is-change');
	}, 500);
};

const setText = () => {
	if (pathName.includes('ss://')) {
		const linuxItem = document.querySelector('.intro__item--linux');
		// langRu.intro.title1 = langRu.intro.title3;
		// langEn.intro.title1 = langEn.intro.title3;
		$introTitle1.innerHTML = langRu.intro.title1;
		langRu.intro.items[4].text = 'Скачать для<br><b>Linux</b>';
		langEn.intro.items[4].text = 'Get in on<br><b>Linux</b>';
		linuxItem.querySelector('.intro__item-text').innerHTML = langRu.intro.items[4].text;
	}
}

const init = () => {
	setText()

	$headerLang.addEventListener('click', () => {
		const lang = $headerLang.dataset.lang;

		changeLang(lang);
	});
};

export default {
	init,
};
